'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _ScreenReducer = require('../../components/screen/ScreenReducer');

var _Notification = require('../../managewidgets/components/notification/Notification');

var _ScreenMessagePanel = require('./ScreenMessagePanel');

var _ScreenMessagePanel2 = _interopRequireDefault(_ScreenMessagePanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTypedScreenMessages = function getTypedScreenMessages(screenMessages, type) {
  return screenMessages.filter(function (screenMessage) {
    return screenMessage.type === type;
  });
};

var mapStateToProps = function mapStateToProps(state, props) {

  var screenMessages = (0, _ScreenReducer.getScreenMessages)(state.screen, props.screenKey);
  screenMessages = screenMessages ? screenMessages.toJS() : [];

  var errorMessages = getTypedScreenMessages(screenMessages, _Notification.NotificationStatus.ERROR);
  var warningMessages = getTypedScreenMessages(screenMessages, _Notification.NotificationStatus.WARNING);
  var successfulMessages = getTypedScreenMessages(screenMessages, _Notification.NotificationStatus.SUCCESSFUL);
  var infoMessages = getTypedScreenMessages(screenMessages, _Notification.NotificationStatus.INFORMATIONAL);

  return {
    errorMessages: errorMessages,
    warningMessages: warningMessages,
    successfulMessages: successfulMessages,
    infoMessages: infoMessages
  };
};

var ScreenMessagePanelContainer = (0, _reactRedux.connect)(mapStateToProps)(_ScreenMessagePanel2.default);

exports.default = ScreenMessagePanelContainer;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/screenmessage/ScreenMessagePanelContainer.js
// module id = 760
// module chunks = 10